<template>
  <div class="tabs border-bottom border-1 border-dark">
    <slot />
  </div>
</template>

<script>
import { provide, computed, reactive } from "vue";

export default {
  name: "Tab",
  props: {
    modelValue: {
      default: '',
      type: String,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const state = reactive({
      active: computed(() => props.modelValue),
    });
    provide("tabs", {
      state,
      activeTab,
    });
    function activeTab(tab) {
      emit("update:modelValue", tab);
    }
  },
};
</script>

<style scoped>
.tabs {
  display: flex;
  flex-wrap: wrap;
  height: 40px;
}
</style>
